import { EntityTable } from '@/features/admin/EntityTable';
import { Badge } from '@/components/ui/Badge';

const EQUIPMENT_TYPES = [
  { value: 'AUTOCLAVE_STEAM', label: 'Autoclave a vapor' },
  { value: 'AUTOCLAVE_PLASMA', label: 'Esterilizador plasma H2O2' },
  { value: 'AUTOCLAVE_ETO', label: 'Esterilizador óxido de etileno' },
  { value: 'WASHER_THERMAL', label: 'Lavadora termo-desinfectora' },
  { value: 'WASHER_ULTRASONIC', label: 'Lavadora ultrassônica' },
  { value: 'SEALER', label: 'Seladora' },
  { value: 'INCUBATOR_BI', label: 'Incubadora BI' },
  { value: 'OTHER', label: 'Outro' },
];

const TYPE_TONE: Record<string, any> = {
  AUTOCLAVE_STEAM: 'info',
  AUTOCLAVE_PLASMA: 'brand',
  AUTOCLAVE_ETO: 'danger',
  WASHER_THERMAL: 'success',
  WASHER_ULTRASONIC: 'success',
  SEALER: 'neutral',
  INCUBATOR_BI: 'warning',
};

export function EquipamentosPage() {
  return (
    <EntityTable
      title="Equipamentos"
      subtitle="Autoclaves, lavadoras, seladoras, incubadoras de BI"
      endpoint="/v1/equipments"
      queryKey="equipments"
      columns={[
        { key: 'code', label: 'Código', className: 'font-mono text-xs' },
        { key: 'name', label: 'Nome' },
        {
          key: 'type', label: 'Tipo',
          render: (r: any) => (
            <Badge tone={TYPE_TONE[r.type] ?? 'neutral'}>
              {EQUIPMENT_TYPES.find(t => t.value === r.type)?.label ?? r.type}
            </Badge>
          ),
        },
        { key: 'manufacturer', label: 'Fabricante', className: 'text-xs text-neutral-500' },
        { key: 'capacity_liters', label: 'L', className: 'text-right tabular-nums text-xs' },
        { key: 'max_load_kg', label: 'kg', className: 'text-right tabular-nums text-xs' },
        {
          key: 'bd', label: 'BD',
          render: (r: any) => r.requires_bowie_dick
            ? (r.bowie_dick_pending ? <Badge tone="danger">Pendente</Badge> : <Badge tone="success">OK</Badge>)
            : <span className="text-xs text-neutral-400">—</span>,
        },
      ]}
      fields={[
        { name: 'code', label: 'Código', type: 'text', required: true },
        { name: 'name', label: 'Nome', type: 'text', required: true },
        { name: 'type', label: 'Tipo', type: 'select', required: true, options: EQUIPMENT_TYPES },
        { name: 'manufacturer', label: 'Fabricante', type: 'text' },
        { name: 'model', label: 'Modelo', type: 'text' },
        { name: 'serial_number', label: 'Nº de série', type: 'text' },
        { name: 'capacity_liters', label: 'Capacidade (L)', type: 'number', min: 0 },
        { name: 'max_load_kg', label: 'Carga máx. (kg)', type: 'number', step: 0.1 },
        { name: 'location_id', label: 'Local', type: 'entity', endpoint: '/v1/locations', displayField: 'name', secondaryField: 'code' },
        { name: 'install_date', label: 'Data de instalação', type: 'date' },
        { name: 'qualified_at', label: 'Qualificado em', type: 'date' },
        { name: 'preventive_due_at', label: 'Próx. preventiva', type: 'date' },
        { name: 'requires_bowie_dick', label: 'Requer Bowie-Dick diário', type: 'checkbox' },
        { name: 'photo_r2_key', label: 'Imagem do equipamento', type: 'image', uploadEntity: 'equipment', uploadKind: 'PHOTO', hint: 'PNG/JPG/WebP até 5 MB' },
      ]}
    />
  );
}
